/**
 * Search synonyms, managed in the theme settings ("Search synonyms").
 * Replaces whole-word matches (case-insensitive) with the configured term,
 * e.g. "hardlid" -> "hard lid".
 */
window.applySearchSynonyms = function (term) {
  const synonyms = (typeof Theme !== 'undefined' && Theme.searchSynonyms) || {};
  const keys = Object.keys(synonyms);
  if (!keys.length) return term;

  const escaped = keys.map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).sort((a, b) => b.length - a.length);
  const pattern = new RegExp(`(^|\\s)(${escaped.join('|')})(?=\\s|$)`, 'gi');
  return term.replace(pattern, (_, lead, match) => lead + synonyms[match.toLowerCase()]);
};

/**
 * Wraps each word in quotes so Shopify matches it exactly instead of fuzzy/semantically
 * ("awning" -> "awning", not ~95 loosely related canopies). Words are quoted individually
 * (not as one phrase) so word order doesn't matter. Quoted phrases the user typed are kept,
 * and running it twice is a no-op.
 * @param {string} term
 */
window.quoteSearchTerms = function (term) {
  const tokens = term.match(/"[^"]*"|\S+/g) || [];
  return tokens
    .map((token) => (/^".+"$/.test(token) ? token : `"${token.replace(/"/g, '')}"`))
    .filter((token) => token !== '""')
    .join(' ');
};

/** @param {string} term */
window.unquoteSearchTerms = function (term) {
  return term.replace(/"/g, '');
};

/**
 * Builds the "Showing results for ..." notice.
 * @param {string} corrected
 * @param {string} original
 * @param {string} searchUrl - URL that searches the original term without synonyms.
 */
window.buildSearchSynonymNotice = function (corrected, original, searchUrl) {
  const t = (typeof Theme !== 'undefined' && Theme.translations) || {};
  const notice = document.createElement('p');
  notice.className = 'search-synonym-notice';
  notice.setAttribute('role', 'status');
  notice.append(
    (t.search_showing_results_for || 'Showing results for "{{ terms }}"').replace(
      '{{ terms }}',
      window.unquoteSearchTerms(corrected)
    )
  );
  if (searchUrl) {
    const link = document.createElement('a');
    link.href = searchUrl;
    link.textContent = (t.search_instead_for || 'Search instead for "{{ terms }}"').replace('{{ terms }}', original);
    notice.append(' ', link);
  }
  return notice;
};

// Search forms (modal + search page input): go straight to the rewritten URL so a normal search
// loads /search once instead of loading it, then redirecting.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') return;
  const input = form.querySelector('input[name="q"]');
  if (!input || !input.value.trim()) return;

  event.preventDefault();
  const url = new URL(form.action, location.origin);
  new FormData(form).forEach((value, key) => {
    if (typeof value === 'string') url.searchParams.set(key, value);
  });
  const typed = input.value;
  const corrected = window.applySearchSynonyms(typed);
  url.searchParams.set('q', window.quoteSearchTerms(corrected));
  if (corrected !== typed) url.searchParams.set('synonym_from', typed);
  location.href = url.toString();
});

// Full search results page. ?exact=1 skips synonyms, ?loose=1 skips quoting (used when a quoted
// search found nothing).
(function () {
  const url = new URL(location.href);
  const q = url.searchParams.get('q');
  if (!q || !/\/search\/?$/.test(url.pathname)) return;

  const original = url.searchParams.get('synonym_from');
  const loose = url.searchParams.get('loose');

  // Direct/old links: rewrite the query (synonyms, then exact-match quoting). scripts.liquid loads
  // this file synchronously on the search page so this runs before any results render.
  if (!original) {
    const corrected = url.searchParams.get('exact') ? q : window.applySearchSynonyms(q);
    const target = loose ? corrected : window.quoteSearchTerms(corrected);
    if (target !== q) {
      url.searchParams.set('q', target);
      if (corrected !== q) url.searchParams.set('synonym_from', q);
      location.replace(url.toString());
      return;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    // The quoted search came back empty (typo etc.) — retry as typed.
    if (!loose && q.includes('"') && document.querySelector('results-list')?.dataset.resultsCount === '0') {
      url.searchParams.set('q', window.unquoteSearchTerms(q));
      url.searchParams.set('loose', '1');
      location.replace(url.toString());
      return;
    }

    if (!original) return;

    const insteadUrl = new URL(url);
    insteadUrl.searchParams.set('q', loose ? original : window.quoteSearchTerms(original));
    insteadUrl.searchParams.delete('synonym_from');
    insteadUrl.searchParams.set('exact', '1');
    const notice = window.buildSearchSynonymNotice(q, original, insteadUrl.toString());
    const header = document.querySelector('.search-page__header');
    header?.append(notice);
  });
})();
